import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import type { SelectOption } from '@rio-cloud/rio-uikit/Select';
import type { IntlShape } from 'react-intl';

import type { OrderStatus } from '#domain/Order.ts';
import type { TourStatus } from '#domain/Tour.ts';

import type { StatusDataRecord } from './StatusOrder.ts';

type FilterProps = {
    id?: string;
    values: string[];
    onFilter: (value: string[]) => void;
    options?: SelectOption[];
    placeholder?: string;
    noItemMessage?: string;
    inputAddon?: string;
    className?: string;
    isLoading?: boolean;
    disabled?: boolean;
    useFilter?: boolean;
    pullRight?: boolean;
    showUnselectedItemIcons?: boolean;
};
export const Filter = ({
    id,
    values,
    onFilter,
    options,
    placeholder,
    noItemMessage,
    inputAddon,
    className,
    isLoading,
    disabled,
    useFilter,
    pullRight = true,
    showUnselectedItemIcons = true,
}: FilterProps) => (
    <Multiselect
        id={id}
        showSelectedItemIcon
        showUnselectedItemIcons={showUnselectedItemIcons}
        pullRight={pullRight}
        value={values}
        options={options}
        dropdownClassName='max-height-none'
        onChange={e => onFilter(e)}
        placeholder={placeholder}
        noItemMessage={noItemMessage}
        inputAddon={inputAddon}
        className={className}
        isLoading={isLoading}
        disabled={disabled}
        useFilter={useFilter}
    />
);

export const getOption = (status: TourStatus | OrderStatus, statusData: StatusDataRecord, intlShape: IntlShape) => {
    return {
        id: status,
        label: intlShape.formatMessage({ id: statusData[status].id }),
        icon: (
            <span
                className={`uikit-icon icon-${statusData[status].icon} text-color-${statusData[status].color} text-size-16`}
            />
        ),
        selected: statusData[status].selected,
    };
};
